import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { ApiClientService, Javna_ponudum } from '../../services/api-client.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-ponude',
  templateUrl: './ponude.component.html',
  styleUrls: ['./ponude.component.scss']
})
export class PonudeComponent implements OnInit {
  constructor(private apiClient: ApiClientService, private cdRef: ChangeDetectorRef, private userService: UserService) {
    this.calculateCurrencyCellValue = this.calculateCurrencyCellValue.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onCopyClick = this.onCopyClick.bind(this);
  }

  currencySymbol: string = 'BAM';
  countries: any[] = [];
  selectedCountry: string = '';
  startDate: Date = new Date(new Date().toDateString());
  endDate: Date = new Date(new Date(new Date().toDateString()).setHours(23, 59, 59, 999));
  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#ponudeGrid' };
  createPonudaPopupVisible: boolean = false;
  editPonudaPopupVisible: boolean = false;
  copyPonudaPopupVisible: boolean = false;
  isUserModerator: boolean = false;

  @ViewChild('ponudeGrid', { static: false }) ponudeGrid: DxDataGridComponent;

  ngOnInit() {
    this.initializeCountries();
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
  }

  initializeCountries() {
    this.countries = [
      { code: 'BiH', name: 'Bosna i Hercegovina' },
      { code: 'Srb', name: 'Srbija' },
      { code: 'Hrv', name: 'Hrvatska' },
      { code: 'Ino', name: 'Uvoz/Izvoz' }
    ];
  }

  onStartDateChange(event: any) {
    this.startDate = event;
  }

  onEndDateChange(event: any) {
    this.endDate = event;
  }

  isFormValid(): boolean {
    return !!this.selectedCountry && !!this.startDate && !!this.endDate;
  }

  toLocalAsUTC(date: Date): Date {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate;
  }

  async loadData() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    var result: any[] = [];
    try {
      switch (this.selectedCountry) {
        case 'BiH':
          result = await this.apiClient.biHAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          this.currencySymbol = 'BAM';
          break;
        case 'Srb':
          result = await this.apiClient.srbAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          this.currencySymbol = 'RSD';
          break;
        case 'Hrv':
          result = await this.apiClient.hrvAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          this.currencySymbol = 'EUR';
          break;
        case 'Ino':
          result = await this.apiClient.inoAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          this.currencySymbol = 'EUR';
          break;
      }

      this.gridData = result;

    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      this.loading = false;
    }
  }

  calculateCurrencyCellValue(data: any): string {
    return data.cijena ? `${data.cijena} ${this.currencySymbol}` : '';
  }

  showCreatePonuda() {
    this.createPonudaPopupVisible = true;
  }

  async onPonudaCreated(e: Javna_ponudum) {
    await this.loadData();
  }

  async onPonudaEdited(e: Javna_ponudum) {
    await this.loadData();
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const ponuda = e.row.data;

    try {
      await this.apiClient.ponudeDELETE(ponuda.id);

      const index = this.gridData.findIndex(item => item.id === ponuda.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting ponuda:', error);
    }
  }

  public selectedPonuda: Javna_ponudum;
  onEditClick(e: any) {
    this.selectedPonuda = e.row.data;
    this.cdRef.detectChanges();
    this.editPonudaPopupVisible = true;
  }

  async onCopyClick(e: any) {
    this.loading = true;
    var tempPonuda = e.row.data;
    delete tempPonuda.firma1;
    delete tempPonuda.artikl1;
    delete tempPonuda.drzava;
    var copyPonuda = { ...e.row.data, id: 0, datum: new Date().toISOString().split('T')[0] };
    await this.apiClient.ponudePOST(copyPonuda);
    this.loading = false;
  }

  onRowPrepared(e: any) {
    if (e.rowType === 'data') {
      // Find the expand/collapse button cell
      const expandCell = e.rowElement.querySelector('.dx-command-expand');

      if (expandCell) {
        // Remove default DevExtreme icons
        const defaultIcons = expandCell.querySelectorAll('.dx-icon');
        defaultIcons.forEach((icon: HTMLElement) => {
          icon.style.display = 'none';
          icon.style.visibility = 'hidden';
        });

        // Add custom FontAwesome icon
        const isExpanded = e.rowElement.classList.contains('dx-row-lines');
        const iconElement = document.createElement('i');
        iconElement.className = isExpanded ? 'fas fa-circle-info' : 'fas fa-circle-info';
        iconElement.style.color = isExpanded ? '#0c8c33' : '#0c8c33';
        iconElement.style.fontSize = '20px';
        iconElement.style.cursor = 'pointer';

        // Clear existing content and add our icon
        expandCell.innerHTML = '';
        expandCell.appendChild(iconElement);
        expandCell.style.textAlign = 'center';
        expandCell.style.verticalAlign = 'middle';
      }
    }
  }
}